export class AuditLogAction {
    Code: string;
    Name: string;
}